module.exports = new __parcel__URL__("lock-closed-darkmode.26d51607.svg").toString();